import React from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import {
  TextField,
  SubmitButton,
  CancelPopupButton,
  SelectFieldV2,
} from 'ui/FormElement';

import { Formik, Form as FormikForm } from 'formik';

import useEnterprises from 'components/Common/Enterprises/Hooks/useEnterprises';
import useReportTemplates from 'components/Common/ReportTemplates/Hooks/useReportTemplates';

import EnterpriseTeam from './Fields/EnterpriseTeam';
import EnterprisePlan from './Fields/EnterprisePlan';

import actions from '../../Actions';

export default function Form({
  reportTemplateId, enterpriseId, closeForm, setReportData,
}) {
  const FormSchema = Yup.object().shape({
    title: Yup.string().required('Please, set Title'),
    enterprise: Yup.number().typeError('Please, choose Enterprise'),
    report_template: Yup.number().typeError('Please, choose Report'),
  });

  const enterprises = useEnterprises();
  const [reportTemplates] = useReportTemplates();

  const formData = {
    title: '',
    report_template: reportTemplateId,
    enterprise: enterpriseId,
    enterprise_teams: [],
    enterprise_plans: [],
  };

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);

    actions.generateReport(values, (data) => {
      setReportData(data);
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ values, isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">

          <TextField
            name="title"
            label={(
              <>
                <span>Title</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <SelectFieldV2
            name="report_template"
            label={(
              <>
                <span>Report</span>
                <abbr title="required">*</abbr>
              </>
            )}
            placeholder={
              reportTemplates == null
                ? 'Reports is loading ...'
                : 'Choose Report...'
            }
            options={reportTemplates !== null ? reportTemplates.map((item) => ({
              label: item.attributes.title,
              value: item.id,
            })) : []}
          />

          <SelectFieldV2
            name="enterprise"
            label={(
              <>
                <span>Enterprise</span>
                <abbr title="required">*</abbr>
              </>
            )}
            placeholder={
              enterprises == null
                ? 'Enterprise is loading ...'
                : 'Choose Enterprise...'
            }
            options={enterprises !== null ? enterprises.map((item) => ({
              label: item.attributes.name,
              value: item.id,
            })) : []}
          />

          <EnterpriseTeam />
          <div style={{ marginTop: '80px' }}>
            <EnterprisePlan />
          </div>

          <div className="text-center mt100 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={closeForm}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Generate'}
              className="btn width-120 btn-primary submit-button mr5 ml5"
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  reportTemplateId: PropTypes.number,
  enterpriseId: PropTypes.number,
  closeForm: PropTypes.func.isRequired,
  setReportData: PropTypes.func.isRequired,
};

Form.defaultProps = {
  reportTemplateId: null,
  enterpriseId: null,
};
